<template>
  <!-- 综合查询 -->
  <div class="statisticalAnalysis">
    <el-row>
      <el-col :span="6"
        ><div class="grid-content bg-purple">
          <el-select
            v-model="query.provinceId"
            filterable
            placeholder="请输入选择省份"
            style="width:80%"
          >
            <el-option label="全部省份" value=""></el-option>
            <el-option
              v-for="item in proList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select></div
      ></el-col>
      <el-col :span="6"
        ><div class="grid-content bg-purple-light">
          <el-select
            v-model="query.examSiteId"
            filterable
            placeholder="请输入选择市代"
            style="width:80%"
          >
            <el-option label="全部市代" value=""></el-option>
            <el-option
              v-for="item in examSitList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select></div
      ></el-col>
      <el-col :span="6"
        ><div class="grid-content bg-purple">
          <el-select
            v-model="query.registerId"
            filterable
            placeholder="请输入选择考点"
            style="width:80%"
          >
            <el-option label="全部考点" value=""></el-option>
            <el-option
              v-for="item in pointsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select></div
      ></el-col>
      <el-col :span="6"
        ><div class="grid-content bg-purple-light">
          <el-select
            v-model="query.appYear"
            filterable
            placeholder="请输入选择年份"
            style="width:80%"
          >
            <el-option label="全部年份" value=""></el-option>

            <el-option
              v-for="item in yearList"
              :key="item.value"
              :label="item.label + '年'"
              :value="item.value"
            ></el-option>
          </el-select></div
      ></el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :span="6"
        ><div class="grid-content bg-purple">
          <el-select
            v-model="query.kspc"
            filterable
            placeholder="请输入选择考试批次"
            style="width:80%"
          >
            <el-option label="全部考试批次" value=""></el-option>

            <el-option
              v-for="item in kspcList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select></div
      ></el-col>
      <el-col :span="6"
        ><div class="grid-content bg-purple-light">
          <el-select
            v-model="query.subjectId"
            filterable
            placeholder="请输入选择科目

"
            style="width:80%"
          >
            <el-option label="全部科目" value=""></el-option>

            <el-option
              v-for="item in subjectsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select></div
      ></el-col>
      <el-col :span="6"
        ><div class="grid-content bg-purple">
          <el-select
            v-model="query.testLevel"
            filterable
            placeholder="请输入选择等级"
            style="width:80%"
          >
            <el-option label="全部等级" value=""></el-option>

            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select></div
      ></el-col>
      <el-col :span="6"
        ><div class="grid-content bg-purple-light">
          <el-button style="width:80%" type="primary" @click="queryClick"
            >查询</el-button
          >
        </div></el-col
      >
    </el-row>
    <el-row :gutter="60" style="margin-top:35px">
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-1.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">报名总人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[0] && tableList[0].value"
                  @click="cardClick(tableList[0].value)"
                >
                  {{ tableList[0].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-2.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">未缴费总人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[1] && tableList[1].value"
                  @click="cardClick(tableList[1].value)"
                >
                  {{ tableList[1].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-3.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">缴费总人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[2] && tableList[2].value"
                  @click="cardClick(tableList[2].value)"
                >
                  {{ tableList[2].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-4.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">视频考试未提交人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[3] && tableList[3].value"
                  @click="cardClick(tableList[3].value)"
                >
                  {{ tableList[3].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-5.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">视频考试总人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[4] && tableList[4].value"
                  @click="cardClick(tableList[4].value)"
                >
                  {{ tableList[4].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-6.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">视频考试不合格人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[5] && tableList[5].value"
                  @click="cardClick(tableList[5].value)"
                >
                  {{ tableList[5].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-4.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">视频考试合格人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[6] && tableList[6].value"
                  @click="cardClick(tableList[6].value)"
                >
                  {{ tableList[6].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-8.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">视频考试优秀人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[7] && tableList[7].value"
                  @click="cardClick(tableList[7].value)"
                >
                  {{ tableList[7].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-9.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">理论考试总人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[8] && tableList[8].value"
                  @click="cardClick(tableList[8].value)"
                >
                  {{ tableList[8].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card10.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">理论考试不合格人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[9] && tableList[9].value"
                  @click="cardClick(tableList[9].value)"
                >
                  {{ tableList[9].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-11.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">理论考试合格人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[10] && tableList[10].value"
                  @click="cardClick(tableList[10].value)"
                >
                  {{ tableList[10].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col :span="6">
        <div class="grid-content bg-purple">
          <div class="card">
            <div class="left">
              <img src="../../../assets/img/card-12.png" alt="" />
            </div>
            <div class="right">
              <div class="right-item1">理论考试优秀人数</div>
              <div class="right-item2">
                <span
                  v-if="tableList && tableList[11] && tableList[11].value"
                  @click="cardClick(tableList[11].value)"
                >
                  {{ tableList[11].label }}
                </span>
                <span v-else></span>
              </div>
            </div>
          </div></div
      ></el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        border
        ref="elTable"
        style="width: 100%;"
        height="550"
        :header-cell-style="$store.getters.getTableHeadStyle"
        v-loading="tableIsLoad"
        element-loading-text="加载中"
        v-el-table-infinite-scroll="getList"
        :infinite-scroll-distance="10"
        :infinite-scroll-disabled="tableDisabled"
      >
        <el-table-column
          key="name"
          prop="name"
          label="姓名"
          width="80"
          align="center"
        ></el-table-column>

        <el-table-column key="sex" width="50" label="性别" align="center">
          <template slot-scope="scope">
        {{ scope.row.sex == 1 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column
          key="idNumber"
          prop="idNumber"
          label="证件号码"
          width="170"
          align="center"
        ></el-table-column>
        <el-table-column
          key="mobile"
          prop="mobile"
          label="联系电话"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          key="expressAddress"
          prop="expressAddress"
          label="快递地址"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          key="provinceName"
          prop="provinceName"
          label="省份"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          key="examSiteName"
          prop="examSiteName"
          label="市级代理"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          key="registrationPointName"
          prop="registrationPointName"
          label="考点"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          key="subjectName"
          prop="subjectName"
          label="报考科目"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          key="testLevel"
          label="报考等级"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.testLevel }}
          </template>
        </el-table-column>
        <el-table-column
          key="amount"
          prop="amount"
          label="应缴费用
"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          key="paymentStatus"
          prop="paymentStatus"
          label="缴费状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.paymentStatus === 1 ? "已缴费" : "未缴费" }}
          </template>
        </el-table-column>
        <el-table-column
          key="score"
          prop="score"
          label="成绩分数"
          width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.score }}
          </template>
        </el-table-column>
        <el-table-column
          key="whetherPass"
          prop="whetherPass"
          label="成绩等级"
          align="center"
          width="100"
          column-key="whetherPass"
        >
          <template slot-scope="{ row }">
            {{ getTextAndColor(row.whetherPass).text }}
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="exportClick">导 出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableIsLoad: false,
      tableDisabled: false,
      tableList: [], //列表数据
      proList: [], //省份下拉
      examSitList: [], //市代下拉
      levelList: [], //报考等级下拉
      pointsList: [], //考点下拉
      subjectsList: [], //考试科目下拉框
      yearList: [], //年份集合
      dialogQuery: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        // total: 1, //总条数
      },
      total: 0,
      kspcList: [
        {
          value: '1',
          label: "春季",
        },
        {
          value: '2',
          label: "夏季",
        },
        {
          value: '3',
          label: "秋季",
        },
        {
          value: '4',
          label: "冬季",
        },
      ],
      query: {
        provinceId: "", // 省份
        examSiteId: "", // 市代
        registerId: "", //  考点
        appYear: "", // 年份
        kspc: "", // 批次
        subjectId: "", // 科目
        testLevel: "", // 等级
      },
      cardList: [
        { value: 1, label: "报名总人数" },
        { value: 2, label: "未缴费总人数" },
        { value: 3, label: "缴费总人数" },
        { value: 4, label: "视频考试未提交人数" },
        { value: 5, label: "视频考试总人数" },
        { value: 6, label: "视频考试不合格人数" },
        { value: 7, label: "视频考试合格人数" },
        { value: 8, label: "视频考试优秀人数" },
        { value: 9, label: "理论考试总人数" },
        { value: 10, label: "理论考试不合格人数" },
        { value: 11, label: "理论考试合格人数" },
        { value: 12, label: "理论考试优秀人数" },
      ],
      dialogVisible: false,
      exportTicketLoading: false,
      dialogTitle: "",

      tableData: [],
      tableHeight: null,
      type: "",
    };
  },
  async mounted() {
    //获取年份数据
    await this.getYearList();
    //获取下拉框数据
    this.getSelectList();
  },
  methods: {
    // handleLoad() {
    //   console.log(123213);
    //   if (this.tableData.length >= this.total) {
    //     return; // 如果已经加载完全部数据，则不再向后台请求数据
    //   }
    //   // 向后台请求新数据
    //   let query = { ...this.query, type: this.type, ...this.dialogQuery };
    //   this.$axios
    //     .post(`/incomeAnalysis/info`, query)
    //     .then((res) => {
    //       this.tableData = [...this.tableData, ...res.data.list];
    //       this.total = res.data.data.total
    //       this.dialogQuery.pageNum++;
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // },
    async getYearList() {
      try {
        const [yearResponse] = await Promise.all([
          this.$axios.get("/incomeAnalysis/selectData"),
        ]);
        // 解构获取当前年度的数据
        this.yearList = yearResponse.data.data;
        if (this.yearList && this.yearList.length > 0) {
          let year = new Date().getFullYear();
          // console.log(year.Number());
          this.query.appYear = year + "";
        }
        // 调用列表接口
        await this.queryClick();

        // 执行接口调用成功后的逻辑
      } catch (error) {
        // 处理错误情况
      }
    },
    // 获取下拉框数据
    async getSelectList() {
      this.$axios.get("/incomeAnalysis/newProvince").then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get("/incomeAnalysis/examinationSite").then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get("/incomeAnalysis/rationSite").then((res) => {
        let data = res.data.data;
        this.pointsList = data;
      });
      this.$axios.get("/incomeAnalysis/level").then((res) => {
        let data = res.data.data;
        this.levelList = data;
      });
      this.$axios.get("/score/subjects").then((res) => {
        let data = res.data.data;
        this.subjectsList = data;
      });
    },
    queryClick() {
      this.tableList = [];
      this.tableIsLoad = true;
      this.$axios
        .post("/incomeAnalysis/queryList", this.query)
        .then((res) => {
          let data = res.data.data;

          let dataArray = [];

          for (const key in data) {
            dataArray.push({ value: parseInt(key), label: data[key] });
          }

          // console.log(dataArray);
          this.tableList = dataArray;
          // const result = this.cardList.map((item) => ({
          //   value: item.value,
          //   label: item.label,
          //   count: data[item.value], // 添加 count 属性，对应数据中的值
          // }));

          // console.log(result);
          // console.log(data_array,'data');
          this.tableIsLoad = false;
        })
        .catch((err) => {
          this.tableIsLoad = false;
        });
    },
    getTextAndColor(val) {
      let text = ["", "合格", "不合格", "优秀"][val],
        color = ["", "#66CC66", "#f56c6c", "#409eff"][val];
      return {
        text,
        color,
      };
    },
    cardClick(value) {
      // console.log(value);
      this.dialogQuery = {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
      };
      this.type = value;
      let query = { ...this.query, type: value, ...this.dialogQuery };
      this.tableIsLoad = true;
      this.dialogVisible = true;
      this.$axios
        .post(`/incomeAnalysis/info`, query)
        .then((res) => {
         
          let data = res.data.data.list;
          this.total = res.data.data.total;
          let title = "";
          const selectedItem = this.cardList.find(
            (item) => item.value === value
          );
          if (selectedItem) {
            title = selectedItem.label;
          }
          this.tableData = data;
          this.dialogTitle = title;
          this.tableIsLoad = false;
        })
        .catch((err) => {
          this.tableIsLoad = false;
        });

      // console.log(this.dialogTitle);
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogTitle = "";
      this.tableData = [];
      this.type = "";
      this.dialogQuery = {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
      };
      this.tableDisabled = false;
    },
    exportClick() {
      this.exportTicketLoading = true;
      let query = { ...this.query, type: this.type };
      this.$axios
        .post("/incomeAnalysis/export/info", query, { responseType: "blob" })
        .then((res) => {
          this.$exportFile(res);
          this.exportTicketLoading = false;
          this.handleClose();
        })
        .catch((err) => {
          this.exportTicketLoading = false;
        });
    },
  async  getList() {
      console.log("1");
      if (this.tableDisabled) return;
      this.dialogQuery.pageNum++;
      let page = Math.ceil(this.total / 15);
      if (this.dialogQuery.pageNum <= page) {
        let query = { ...this.query, type: this.type, ...this.dialogQuery };
     await   this.$axios
          .post(`/incomeAnalysis/info`, query)
          .then((res) => {
            let data = res.data.data.list;
            this.total = res.data.data.total;
            this.tableData = this.tableData.concat(data);
            console.log(this.tableData);
          })
          .catch((error) => {});
      }
      if (this.dialogQuery.pageNum > page) {
        this.tableDisabled = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.statisticalAnalysis {
  .tableHearInputBox {
    .el-select {
      width: 140px;
      margin-right: 10px;
    }
  }
  .card {
    height: 9.375rem /* 150/16 */;
    display: flex;
    background-color: #fff;
    box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.0980392156862745);
    align-items: center;
    margin-bottom: 30px;
    .left {
      width: 35%;

      text-align: center;
    }

    .right {
      display: flex;
      flex-direction: column;
      width: 65%;
      height: 9.375rem /* 150/16 */;

      justify-content: center;
    }
  }

  .right-item1 {
    font-size: 20px;
    color: #001c31;
    margin-bottom: 0.9375rem /* 15/16 */;
  }
  .right-item2 {
    font-size: 36px;
    color: #1890ff;
  }
}
</style>
<style lang="scss">
.el-table__expand-icon {
  padding-top: 5px !important;
}
</style>
